import React, { Component } from 'react';

import history from '../../history';
import Button from '../inputs/Button';
import { InputRow } from '../inputs';

import './index.css';

export default class ErrorPage extends Component {
  render() {
    return (
      <div className="errorPage">
        <img
          style={{
            width: '500px',
            alignSelf: 'center'
          }}
          src={require('../../assets/images/iReport_grey_green.png')}
          alt="broken app link"
        />

        <h2>An error occurred</h2>
        <h4>
          Please try again later or contact support@ireportsource.com or (513)
          549-3459.
        </h4>
        <InputRow center>
          <Button
            color="white"
            text="Back to Login"
            onClick={() => history.push('/login')}
          />
        </InputRow>
      </div>
    );
  }
}
